export default "__VITE_ASSET__cd939567__"